import { render, staticRenderFns } from "./CabinetIncidents.vue?vue&type=template&id=6ac1dca7"
import script from "./CabinetIncidents.vue?vue&type=script&lang=js"
export * from "./CabinetIncidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports